import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from './../app-config/app-config.service';
import { EventStreamObject } from '../shared/models/deviceInfo.model';
import { Observable, throwError, of, BehaviorSubject, Subject, zip } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeviceConfigurationService {

  private _configuredTags = {};
  private _attachedEquipments = [];
  private _tagStreams = [];
  private _configuredtagStreams = {};
  private _deviceOverview = {};
  private _nodeChannels = [];
  private _nodeConfigId = '';
  private _nodeId = '';
  private _eqpmentInfoForTagStreams = {};
  private _eqpmentInfoForeventStream = {};


  private _eventStream = {};
  private _noStream = {}
  private _realtimeStream = {};

  private _publishRate : number;
  private deviationChanged = new BehaviorSubject<any>({});
  private streamTypeChanged = new BehaviorSubject<any>({});

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService
  ) { }


  public getDeviationChanged(): Observable<any> {
    return this.deviationChanged.asObservable();
  }

  setDeviationChanged = (val: any) => {
    return this.deviationChanged.next(val);
  }

  public getStreamTypeChanged(): Observable<any> {
    return this.streamTypeChanged.asObservable();
  }

  setStreamTypeChanged = (val: any) => {
    return this.streamTypeChanged.next(val);
  }


  /** For device overview */
  set deviceOverview(data: any) {
    this._deviceOverview = data;
  }

  get deviceOverview() {
    return this._deviceOverview;
  }


  /** For Configure tags */
  set configuredTags(data: any) {
    this._configuredTags = data;
  }

  get configuredTags() {
    return this._configuredTags;
  }

  set attachedEquipments(data: any) {
    this._attachedEquipments = data;
  }

  get attachedEquipments() {
    return this._attachedEquipments;
  }

  /** For Remote Comms */
  set tagStreams(data: any) {
    this._tagStreams = data;
  }

  get tagStreams() {
    return this._tagStreams;
  }

  set configuredTagStreams(data: any) {
    this._configuredtagStreams = data;
  }

  get configuredTagStreams() {
    return this._configuredtagStreams;
  }

  /** For Setup equipments */
  get nodeChannels() {
    return this._nodeChannels;
  }

  set nodeChannels(data){
    this._nodeChannels = data;
  }
  

  get nodeId(){
    return this._nodeId;
  }

  set nodeId(data){
    this._nodeId = data
  }

  get nodeConfigId(){
    return this._nodeConfigId;
  }
  
  set nodeConfigId(data){
    this._nodeConfigId = data
  }

  /**
   * Tags info for each equipemnt
   */
  set eqpmentInfoForTagStreams(data){
    this._eqpmentInfoForTagStreams = data
  }

  get eqpmentInfoForTagStreams(){
    return this._eqpmentInfoForTagStreams;
  }

    /**
   * Tags info for each equipemnt
   */
     set eqpmentInfoForeventStream(data){
      this._eqpmentInfoForeventStream = data
    }
  
    get eqpmentInfoForeventStream(){
      return this._eqpmentInfoForeventStream;
    }


  /**
   * Reset all states
   */
  resetAllStates(){
    this.configuredTags = {};
    this.attachedEquipments = [];
    this.tagStreams = [];
    this.configuredTagStreams = {};
    this.deviceOverview = {};
    this.nodeChannels = [];
    this.nodeId='';
    this.nodeConfigId='';
    this.eqpmentInfoForTagStreams = {};
    this.eqpmentInfoForeventStream = {};
    this.deviationChanged.next({});
    this.streamTypeChanged.next({});
  }

  getTagUnits() {
    return this.http.get(this.appConfigService.getConfig().apiBaseUrl + "TagData/Units");
  }

  /** For Remote Comms */
  set realtimeStream(data: any) {
    this._realtimeStream = data;
  }

  get realtimeStream() {
    return this._realtimeStream;
  }

  set eventStream(data: EventStreamObject) {
    this._eventStream = data;
  }

  get eventStream() {
    return this._eventStream;
  }

   /** For Remote Comms */
   set noStream(data: EventStreamObject) {
    this._noStream = data;
  }

  get noStream() {
    return this._noStream;
  }
  
  set publishRate(data: number) {
    this._publishRate = data;
  }
  
  get publishRate() {
    return this._publishRate;
  }
}
